export default __webpack_public_path__ + "static/media/Project-2-PortfolioPage-MainImg.c9f79ba2.png";